import { error, success } from '../../theme/colors';

import {
  CandleData,
  CandleDataRequest,
  CandleDataRespose,
  CandleRequestParams,
} from './interfaces/candle_data';

class CandleRequest implements CandleDataRequest {
  jsonrpc: string;
  method: string;
  id: string;
  params: CandleRequestParams;

  constructor(
    id: string,
    begin: string,
    end: string,
    interval: string,
    source: string,
    undelying: string,
    label: string,
  ) {
    this.id = id;
    this.jsonrpc = '2.0';
    this.method = 'candlestick';
    this.params = new CandleParams(begin, end, interval, source, undelying, label);
  }
}

class CandleSubscriptionRequest implements CandleDataRequest {
  jsonrpc: string;
  method: string;
  id: string;
  params: any;

  constructor(
    id: string,
    begin: string,
    interval: string,
    source: string,
    underlying: string,
    label: string,
  ) {
    this.id = id;
    this.jsonrpc = '2.0';
    this.method = 'subscribe.candlestick';
    this.params = { begin, interval, source, underlying, label };
  }
}

class CandleParams implements CandleRequestParams {
  begin: string;
  end: string;
  interval: string;
  source: string;
  underlying: string;
  label: string;

  constructor(
    begin: string,
    end: string,
    interval: string,
    source: string,
    undelying: string,
    label: string,
  ) {
    this.begin = begin;
    this.end = end;
    this.interval = interval;
    this.source = source;
    this.underlying = undelying;
    this.label = label;
  }
}

class CandleResponse implements CandleDataRespose {
  jsonrpc: string;
  id: string;
  result: CandleStick[];

  constructor(id: string, jsorpc: string, result: any[]) {
    this.id = id;
    this.jsonrpc = jsorpc;
    this.result = result?.map((el) => new CandleStick(el));
  }
}

class HollowCandleResponse implements CandleDataRespose {
  jsonrpc: string;
  id: string;
  result: CandleStick[];

  constructor(id: string, jsorpc: string, result: any[]) {
    this.id = id;
    this.jsonrpc = jsorpc;
    this.result = result?.map((el) => new HollowCandleStick(el));
  }
}

class HistogramResponse implements CandleDataRespose {
  jsonrpc: string;
  id: string;
  result: CandleStick[];

  constructor(id: string, jsorpc: string, result: any[]) {
    this.id = id;
    this.jsonrpc = jsorpc;
    this.result = result?.map((el) => new Histogram(el));
  }
}

class CandleStick implements CandleData {
  time: number;
  open: string;
  high: string;
  low: string;
  close: string;
  value?: string;

  constructor(jsonData: any[]) {
    const dateStr = jsonData[0].split(' ')[0];
    const timeStr = jsonData[0].split(' ')[1];

    const date = new Date(
      Date.UTC(
        dateStr.split('-')[0],
        dateStr.split('-')[1] - 1,
        dateStr.split('-')[2],
        timeStr.split(':')[0],
        timeStr.split(':')[1],
        timeStr.split(':')[2],
      ),
    );
    this.time = date.getTime() / 1000;
    this.open = jsonData[1];
    this.high = jsonData[2];
    this.low = jsonData[3];
    this.close = jsonData[4];
    this.value = jsonData[5] ?? jsonData[4];
  }
}

class HollowCandleStick implements CandleData {
  time: number;
  open: string;
  high: string;
  low: string;
  close: string;
  color?: string;

  constructor(jsonData: any[]) {
    const dateStr = jsonData[0].split(' ')[0];
    const timeStr = jsonData[0].split(' ')[1];

    const date = new Date(
      Date.UTC(
        dateStr.split('-')[0],
        dateStr.split('-')[1] - 1,
        dateStr.split('-')[2],
        timeStr.split(':')[0],
        timeStr.split(':')[1],
        timeStr.split(':')[2],
      ),
    );
    this.time = date.getTime() / 1000;
    this.open = jsonData[1];
    this.high = jsonData[2];
    this.low = jsonData[3];
    this.close = jsonData[4];
    this.color = parseFloat(this.close) >= parseFloat(this.open) ? 'transparent' : undefined;
  }
}

class Histogram implements CandleData {
  time: number;
  open: string;
  high: string;
  low: string;
  close: string;
  value?: string;
  color?: string;

  constructor(jsonData: any[]) {
    const dateStr = jsonData[0].split(' ')[0];
    const timeStr = jsonData[0].split(' ')[1];

    const date = new Date(
      Date.UTC(
        dateStr.split('-')[0],
        dateStr.split('-')[1] - 1,
        dateStr.split('-')[2],
        timeStr.split(':')[0],
        timeStr.split(':')[1],
        timeStr.split(':')[2],
      ),
    );
    this.time = date.getTime() / 1000;
    this.open = jsonData[1];
    this.high = jsonData[2];
    this.low = jsonData[3];
    this.close = jsonData[4];
    this.value = this.close;
    this.color = parseFloat(this.close) > parseFloat(this.open) ? success[3] : error[3];
  }
}

export {
  CandleRequest,
  CandleResponse,
  CandleStick,
  CandleSubscriptionRequest,
  HistogramResponse,
  HollowCandleResponse,
};
